import { render, staticRenderFns } from "./_sitesTableFE.vue?vue&type=template&id=c65a5a18"
import script from "./_sitesTableFE.vue?vue&type=script&lang=js"
export * from "./_sitesTableFE.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports